import ProgressBar from '../ProgressBar/ProgressBar'

import styles from '../Eix/Eix.module.css'  

const Eix = (props) => {
    const percentage = props.percentatge
    return (
        <div className={props.type === "home" ? styles.container2 : styles.container}>
            <div className={props.type === "home" ? styles.title : styles.title1}>
                {
                    props.type === "h1" ? <h1>{props.name}</h1> : props.type === "home" ? <h2>{props.name}</h2> : <h3>{props.name}</h3>
                }
                {
                    props.descripcio && <p className={props.type === "home" ? styles.descripcio2 : styles.container}>{props.descripcio}</p>
                }
                {
                    props.exemple && <p className={styles.exemple}>{props.exemple}</p>
                }
                {
                    props.type === "h1" && <p className={styles.llegenda}>Els indicadors negres són els resultats actuals. Els indicadors blaus indiquen la previsió dels resultats a 31/12/2026</p>

                }
            </div>
            <div className={props.type === "h1" ? styles.pbar : props.type === "h3" ? styles.pbar2 : styles.pbar3}>
                <ProgressBar value={percentage}></ProgressBar>
                {
                    props.type === "h1" && props.type === "home" && <p className={styles.llegenda2}>Compliment</p>

                }
            </div>
        </div>
    )
}

export default Eix